module.exports = __webpack_public_path__ + "images/file_icons_v2/zip-48033fb6a43a8563a65bf0fd332840b0.svg";